import { render, staticRenderFns } from "./CommercialClue.vue?vue&type=template&id=0837655c&scoped=true&"
import script from "./CommercialClue.vue?vue&type=script&lang=js&"
export * from "./CommercialClue.vue?vue&type=script&lang=js&"
import style0 from "./CommercialClue.vue?vue&type=style&index=0&id=0837655c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0837655c",
  null
  
)

export default component.exports